import { render, staticRenderFns } from "./FlexTablePro.vue?vue&type=template&id=6244c806&scoped=true"
import script from "./FlexTablePro.vue?vue&type=script&lang=js"
export * from "./FlexTablePro.vue?vue&type=script&lang=js"
import style0 from "./FlexTablePro.vue?vue&type=style&index=0&id=6244c806&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244c806",
  null
  
)

export default component.exports